import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CvCustomDialogService } from 'src/app/reusables/custom-dialog/cv-custom-dialog.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { FormGroup } from '@angular/forms';
import { ImageValidation, TemplateStringImage } from '../../models/marketplace-product-image.model';
import { PointStoreProductEditService } from 'src/app/gamification/marketplace/admin/services/point-store-product-edit.service';
import { FilesizeformatPipe } from '../../pipes/filesizeformat.pipe'

import { orderBy } from 'lodash';
import OverlayScrollbars from 'overlayscrollbars';
import { PointStoreProductEdit } from '../../models/point-store-product-edit.model';

@Component({
  selector: 'cv-point-store-product-upload-cxone',
  templateUrl: './cv-point-store-product-upload-cxone.component.html',
  styleUrls: ['./cv-point-store-product-upload-cxone.component.scss']
})
export class CvPointStoreProductUploadCxoneComponent implements OnInit {

  @Input() formDataBinding: FormGroup;
  @Output() areValidVariationImages = new EventEmitter<boolean>();

  @ViewChild('pointStoreUploadInput') pointStoreUploadInput: ElementRef<HTMLInputElement>;
  @ViewChild('pointStoreUploadInputSingle') pointStoreUploadInputSingle: ElementRef<HTMLInputElement>;

  pspes: PointStoreProductEdit = null;
  private maxImgSize = 5242880; //5MB expressed in bytes
  modifiedIndex = null;
  isVariation = false;
  isTemp = false;
  tempImageString: TemplateStringImage[] = [];
  product = null;
  originalImagesModified: boolean = false;
  uploadAgain: boolean = false;
  newImagesValidation = []

  prodUploadOptions: OverlayScrollbars.PartialOptions = {
    scrollbars: {
      visibility: 'visible',
      autoHide: "leave",
      autoHideDelay: 100,
      theme: "custom-scrollbar"
    },
    overflow: {
      x: 'hidden',
      y: 'scroll'
    },
  };

  constructor(
    private pointStoreProductEditService: PointStoreProductEditService,
    private dialogService: CvCustomDialogService,
    private filesizeformatPipe: FilesizeformatPipe,
    public cvLocalizationService: CVLocalizationService) {
    this.pspes = this.pointStoreProductEditService.pointStoreProductEditObj;
  }

  ngOnInit(): void {
  }
  
  showErrorMessage() {
   return this.cvLocalizationService.getCachedText('MarketPlace_Management', 'Upload_Again', 'Upload again');
  }

  async handleFileSelect(event: Event) {
    const element = event.currentTarget as HTMLInputElement;
    const files: FileList = element.files;
    let imagesToUpload = (files.length + this.currentUploadedImages() > 5) ? (5 - this.currentUploadedImages()) : files.length;
    const imagesWithValidation = await this.fileValidationAndUpload(files, imagesToUpload);
    //if the validation is true trigger the modal to display the message
    const isDisplayErrorModal = imagesWithValidation.some(images => !images.valid)
    if (isDisplayErrorModal) {
      this.messageForImageValidation(imagesWithValidation);
    }
    this.pointStoreUploadInput.nativeElement.value = '';
  }

  handleSingleFileSelect(event: Event): void {
    const element = event.currentTarget as HTMLInputElement;
    const file = element.files[0];

    //If the image is not JPG/JPEG/PNG, or it has a size bigger than the max size allowed, is ignored
    if ((file.type != "image/png" && file.type != "image/jpeg") || (file.size > this.maxImgSize)) {
      if (this.isVariation) {
        this.pspes.modifiedPointStoreProduct.VariationsData[this.modifiedIndex].validation = true;
        delete this.pspes.modifiedPointStoreProduct.VariationsData[this.modifiedIndex].VariationImageData;
      } else {
        if (this.pspes.modifiedPointStoreProduct.imageString[this.modifiedIndex] == undefined) {
          let id = orderBy(this.pspes.modifiedPointStoreProduct.imageString, ['id'], ['desc'])[0]?.id ?? 0;
          id = id + 1;
          this.pspes.modifiedPointStoreProduct.imageString.push({ id, validation: true });
        } else {
          this.pspes.modifiedPointStoreProduct.imageString[this.modifiedIndex].validation = true;
          delete this.pspes.modifiedPointStoreProduct.imageString[this.modifiedIndex].source;
        }
      }
      this.areValidVariationImages.emit(true);
      return;
    }

    let reader = new FileReader();
    reader.onload = (evt) => {
      setTimeout(() => {
        if (this.isTemp) {
          this.tempImageString[this.modifiedIndex].source = evt.target.result;
          this.tempImageString[this.modifiedIndex].name = file.name;
        } else {
          if (this.isVariation) {
            this.pspes.modifiedPointStoreProduct.VariationsData[this.modifiedIndex].validation = false;
            this.pspes.modifiedPointStoreProduct.VariationsData[this.modifiedIndex].VariationImageData = evt.target.result;
            if(!this.newImagesValidation.some(images => images.id === this.modifiedIndex)){
                this.newImagesValidation.push({id: this.modifiedIndex});
            }
          } else {
            if (this.pspes.modifiedPointStoreProduct.imageString[this.modifiedIndex] == undefined) {
              let id = orderBy(this.pspes.modifiedPointStoreProduct.imageString, ['id'], ['desc'])[0]?.id ?? 0;
              id = id + 1;
              this.pspes.modifiedPointStoreProduct.imageString.push({ id, name: file.name, source: evt.target.result, validation: false });
            } else {
              this.pspes.modifiedPointStoreProduct.imageString[this.modifiedIndex].source = evt.target.result;
              this.pspes.modifiedPointStoreProduct.imageString[this.modifiedIndex].name = file.name;
              this.pspes.modifiedPointStoreProduct.imageString[this.modifiedIndex].validation = false;
            }
          }
          this.areValidVariationImages.emit(true);
        }
      }, 0);
    };
    reader.readAsDataURL(file);
    this.pointStoreUploadInputSingle.nativeElement.value = '';
  }

  triggerUploadSingleClick($event, index, isVariation, isTemp = null): void {
    this.modifiedIndex = index;
    this.isVariation = isVariation;
    this.isTemp = isTemp;
    let $clicked = $($event.target);
    $clicked.parents(".form-upload").find(".pointStoreUploadInputSingle").trigger("click");
  }

  shouldShowUploadedImage(): boolean {
    if (this.product != this.pspes.modifiedPointStoreProduct)
      this.originalImagesModified = false;

    this.product = this.pspes.modifiedPointStoreProduct;
    if (this.product == null) return false;

    if (this.product.MultipleImagesData != null && this.product.MultipleImagesData.length > 0 && this.product.imageString != null && this.product.imageString.length == 0 && !this.originalImagesModified) {
      for (let i = 0; i < this.product.MultipleImagesData.length; i++) {
        if (this.product.MultipleImagesData[i].PointStoreProductVariationID != null) {
          if (this.pspes.modifiedPointStoreProduct.VariationsData != null) {
            let variationIndex = this.pspes.modifiedPointStoreProduct.VariationsData.findIndex((v) => { return v.PointStoreProductVariationID == this.product.MultipleImagesData[i].PointStoreProductVariationID; });
            if (variationIndex > -1 && !this.newImagesValidation.some(images => images.id === variationIndex))
              this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationImageData = '../Admin/ImageResizer.aspx?imgid=' + this.product.MultipleImagesData[i].PointStoreProductImageID + '&w=auto&h=220';
          }
        } else {
          this.pspes.modifiedPointStoreProduct.imageString.push({ name: "", source: '../Admin/ImageResizer.aspx?imgid=' + this.product.MultipleImagesData[i].PointStoreProductImageID + '&w=auto&h=220', validation: false })
        }
      }
    } else if (this.product.ProductImageID != 0 && (this.product.imageString != null && this.product.imageString.length == 0 || this.product.imageString == null) && !this.originalImagesModified) {
      this.pspes.modifiedPointStoreProduct.imageString = [];
      this.pspes.modifiedPointStoreProduct.imageString.push({ name: "", source: '../Admin/ImageResizer.aspx?imgid=' + this.pspes.modifiedPointStoreProduct.ProductImageID + '&w=auto&h=220', validation: false })
    }
    return (this.product.imageString != null && this.product.imageString.length > 0) || (this.product.ProductImageID != null && this.product.ProductImageID > 0);
  }

  /**
   * method to remove the image from the main section
   * @param index current index
   * @param isTemp temp image
   */
  removeImage(index, isTemp): void {
    if (isTemp) {
      this.tempImageString.splice(index, 1);
    } else {
      this.pspes.modifiedPointStoreProduct.imageString.splice(index, 1);
      this.originalImagesModified = true;
      if (!this.pspes.modifiedPointStoreProduct.imageString.length)
        this.pspes.modifiedPointStoreProduct.ProductImageID = 0;
    }
    this.areValidVariationImages.emit(true);

  }

  /**
   * method to remove the variant image from the variant section
   * @param index current index
   */
  removeVariationImage(index): void {
    this.pspes.modifiedPointStoreProduct.VariationsData[index].VariationImageData = null;
    this.originalImagesModified = true;
    this.areValidVariationImages.emit(true);
  }

  /**
   * @param index current image index
   * @returns boolean value to display the init state of the card
   */
  validateInitState(index: number): boolean {
    const imageString = this.pspes.modifiedPointStoreProduct.imageString[index];
    return ((this.shouldShowUploadedImage() && (imageString == null || imageString == undefined)) || !this.shouldShowUploadedImage());
  }

  /**
   * @param index current image index
   * @returns boolean value to display the image container
   */
  validateDisplayImgContainer(index: number): boolean {
    const imageString = this.pspes.modifiedPointStoreProduct.imageString;
    return (imageString != null && imageString?.length > 0 && imageString?.[index] != undefined);
  }

  /**
   * method for uploading and validating an image in multiple mode
   * @param files list of files
   * @param imagesToUpload number of images to upload
   * @returns array with images and errors
   */
  async fileValidationAndUpload(files: FileList, imagesToUpload: number): Promise<ImageValidation[]> {
    let imagesWithValidation: ImageValidation[] = [];
    const fileList = []
    for (let i = 0; i < imagesToUpload; i++) {
      const { name, type, size } = files[i];
      const { isValid, error } = this.validFiles(name, type, size);
      imagesWithValidation.push({ name: name, valid: isValid, errorMessage: error, validation: !isValid, size });
      fileList.push(files[i]);
    }

    let finalFileList = [...fileList];
    let images = await Promise.all(finalFileList.map((file) => { return this.readAsDataUrl(file) }));
    //we don't need images with validation true
    this.pspes.modifiedPointStoreProduct.imageString = this.pspes.modifiedPointStoreProduct.imageString?.filter(images => !images.validation);
    //id creation
    let id = orderBy(this.pspes.modifiedPointStoreProduct.imageString, ['id'], ['desc'])[0]?.id ?? 0;
    images.forEach((file: any) => {
      id = id + 1;
      this.pspes.modifiedPointStoreProduct.imageString.push({ id, name: file.name, source: file.source, validation: file.validation });
    });
    this.areValidVariationImages.emit(true);
    return imagesWithValidation;
  }

  /**
  * method to create the custom message that displays the modal
  * @param imgArray array with images and errors
  */
  messageForImageValidation(imgArray: ImageValidation[]): void {
    const modalTitle = this.cvLocalizationService.getCachedText("MarketPlace_Management_Messages", "Validate_Error_Uploading_Images_Title", "Error Uploading Images");
    let prompt = `<span class="validation-modal-body">${this.cvLocalizationService.getCachedText("MarketPlace_Management_Messages", "Validate_Size_Limit_Format_File", "Each file must be up to 5 MB. Only JPG, JPEG and PNG files can be uploaded.")}</span>`;
    prompt += `<div class="w-100 mt-2">`;

    imgArray?.forEach(imageObj => {
      if (imageObj.valid) {
          prompt += `<div class="validation-modal-body row mt-1">
                        <div class="col-8 pr-0" title="${imageObj.name}">
                            <svg class="icon-16 valid"><use href="../App_Themes/CXone/icons/gamification/valid.svg#valid"></use></svg>
                             ${this.truncateFileName(imageObj.name, 20)} <span class="file-size">(${this.filesizeformatPipe.transform(imageObj.size)})</span>
                        </div></div>`;
      } else {
          prompt += `<div class="validation-modal-body row mt-1">
                        <div class="col-8 pr-0" title="${imageObj.name}">
                            <svg class="icon-16 invalid"><use href="../App_Themes/CXone/icons/gamification/invalid.svg#invalid"></use></svg>
                             ${this.truncateFileName(imageObj.name, 20)} <span class="file-size">(${this.filesizeformatPipe.transform(imageObj.size)})</span>
                        </div><div class="col-4 invalid-text px-0 text-truncate text-right" title="${imageObj.errorMessage}">${imageObj.errorMessage}</div></div>`;
      }
    });
    prompt += `</div>`;

    const cancelLabel = '';
    const okLabel = this.cvLocalizationService.getCachedText("Common", "Ok", "Ok");
    this.dialogService.showDialog(modalTitle, prompt, 2, cancelLabel, okLabel, true, () => { }, () => { }, 'upload-dialog', true);
  }
  
  truncateFileName(str: string, maxLengthAllow: number) {
    if (maxLengthAllow >= str.length) {
      return str;
    }
    const halfMaxLengthAllow = Math.floor(maxLengthAllow / 2);
    
    let fileName = str.match(/^.*(?=\.[^.]+$)/g)[0];
    
    let trimmedfielName = fileName.substring(0, halfMaxLengthAllow) + "..." + fileName.substring(str.length - halfMaxLengthAllow);
    
    return str.replace(/^.*(?=\.[^.]+$)/g, trimmedfielName);
  }

   /**
   * count if there are images in the image array
   * @returns array length
   */
   currentUploadedImages(): number {
    return (this.pspes.modifiedPointStoreProduct?.imageString || []).filter(images => images?.source !== undefined).length;
  }

  /**
   * method for validate files
   * @param name file name
   * @param type file type
   * @param size file size
   * @returns 
   */
  validFiles(name: string, type: string, size: number) {
    let isValid = true;
    let error: string | undefined;
    if (type != "image/png" && type != "image/jpeg") {
      isValid = false;
      error = this.cvLocalizationService.getCachedText("MarketPlace_Management_Messages", "Validate_Invalid_Formatt_File_Error", "Unsupported format");
    }
    if (size > this.maxImgSize) {
      isValid = false;
      error = this.cvLocalizationService.getCachedText("MarketPlace_Management_Messages", "Validate_Size_Limit_File_Error", "Exceeded file size limit");
    }
    return { isValid, error };
  }

  /**
   * method that returns every image with basic info
   * @param file file
   * @returns Images with basic info
   */
  readAsDataUrl(file) {
    return new Promise((resolve, reject) => {
      let fileReader = new FileReader();
      fileReader.onload = (evt) => {
        const { isValid } = this.validFiles(file.name, file.type, file.size);
        if(isValid){
          resolve({ source: evt.target.result, validation: false, name:file.name, size: file.size, type: file.type })
        }else {
          resolve({ validation: true })
        }
      }
      fileReader.readAsDataURL(file)
    })
  }
}
